"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.list.title': 'Preguntas',
    'question.list.empty': 'No se encontraron preguntas',
};
